import ActionButton from '!!raw-loader!./ActionButton.vue'
import CycleButton from '!!raw-loader!./CycleButton'
import Dropdown from '!!raw-loader!./Dropdown'
// import DropdownIcon from '!!raw-loader!./DropdownIcon'
import Icon from '!!raw-loader!./Icon.vue'
// import NavLink from '!!raw-loader!./NavLink'
import QuickActions from '!!raw-loader!./QuickActions'
import SideNav from '!!raw-loader!./SideNav'
import Tabs from '!!raw-loader!./Tabs'
import Toggle from '!!raw-loader!./Toggle.vue'
import Tool from '!!raw-loader!./Tool.vue'

export default {
  ActionButton,
  CycleButton,
  Dropdown,
  // DropdownIcon,
  Icon,
  // NavLink,
  QuickActions,
  SideNav,
  Tabs,
  Toggle,
  Tool,
}
